import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ReactComponent as WarningIcon } from '../../../../assets/images/common/icons/warning-icon.svg'
import Modal from '../../../common/Modal'
import SubmitButton from '../../../common/buttons/SubmitButton'
import styles from './ExitModal.module.scss'

const ExitModal = ({ showModal, closeModal, onExit }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      className={styles['exit-program-builder-modal-content']}
    >
      <section className='animated fadeIn'>
        <div>
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <WarningIcon className='mt-2' />
            <p className={styles.title}>{t('programs.builder.exitModal.title')}</p>
            <p className={styles.message}>
              {t('programs.builder.exitModal.message')}
            </p>
          </div>
          <div className='row py-3'>
            <div className='col-12'>
              <SubmitButton
                onClick={closeModal}
                buttonMessage={t('programs.builder.exitModal.backToProgram')}
                buttonColor='orange-button'
              />
            </div>
            <div className='col-12'>
              <SubmitButton
                onClick={onExit}
                buttonMessage={t('programs.builder.exitModal.exit')}
                buttonColor='navy-button'
              />
            </div>
          </div>
        </div>
      </section>
    </Modal>
  )
}

ExitModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired,
}

export default ExitModal
